export const generateUID = (length: number): string => {
  return window.btoa(
    Array.from(window.crypto.getRandomValues(new Uint8Array(length * 2)))
      .map(c => String.fromCodePoint(c)).join('')
  ).replace(/[+/]/g, '').substring(0, length);
};

export const getBaseUrl = (): string => {
  return `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' : ''}${window.location.port}`;
};

export const getPostFormHubspotUrl = (portalId: string, formGuid: string): string => {
  return `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`;
};

export const filterDuplicates = <T extends { id: string | number }>(array: T[]): T[] => {
  return array.reduce((unique: T[], o: T) => {
    if (!unique.some((obj: T) => obj.id === o.id)) {
      unique.push(o);
    }
    return unique;
  }, []);
};

export const cleanWhiteSpaces = (string?: string): string | undefined =>
  string?.split(' ').filter((item) => item !== '').join(' ');

export const fadingClassName = (state: boolean): string => {
  return `${!state ? 'fadeIn' : 'fadeOut'}`;
};

export const megabytesToBytes = (size: string): number => {
  const units: { [key: string]: number } = {
    B: 1,
    Kb: 1024,
    Mb: 1024 * 1024,
    Gb: 1024 * 1024 * 1024,
    Tb: 1024 * 1024 * 1024 * 1024
  };

  const match = size.match(/^(\d\d*)(B|Kb|Mb|Gb|Tb)$/);

  if (!match) {
    throw new Error(`Invalid size format: ${size}`);
  }

  const [, value, unit] = match;
  const bytes = Number.parseFloat(value) * units[unit];

  return bytes;
}
